
















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import User from "@/models/user/User";
import UserCardRightsDriver from "@/components/user/UserCardRightsDriver.vue";
import UserCardRightsOffice from "@/components/user/UserCardRightsOffice.vue";
import UserCardRightsCustomer from "@/components/user/UserCardRightsCustomer.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import UserCardRightsAdmin from "@/components/user/UserCardRightsAdmin.vue";
import UserCardRightsInternal from "@/components/user/UserCardRightsInternal.vue";
import {Roles, Permissions} from "@/helpers/constants";

@Component({
	components: {
		UserCardRightsInternal,
		UserCardRightsAdmin,
		AsiContentContainer, UserCardRightsCustomer, UserCardRightsOffice, UserCardRightsDriver
	}
})
export default class UserTabRights extends Vue {

	@Prop({type: Object, required: true})
	public user!: User;

	@Prop({type: Array, required: true})
	public roles!: Roles[];

	@Prop({type: Array, required: true})
	public permissions!: Permissions[];

	@Emit('rightsChanged')
	public rightsChanged(): void {
	    return;
	}

}
